interface OverfitBadgeProps {
  ratio: number;
}

export default function OverfitBadge({ ratio }: OverfitBadgeProps) {
  let label: string;
  let colorClasses: string;

  if (ratio > 0.7) {
    label = "✅ Low risk";
    colorClasses = "text-green-400 bg-green-500/10 border-green-500/20";
  } else if (ratio >= 0.5) {
    label = "⚠️ Moderate";
    colorClasses = "text-amber-400 bg-amber-500/10 border-amber-500/20";
  } else {
    label = "❌ High risk";
    colorClasses = "text-red-400 bg-red-500/10 border-red-500/20";
  }

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border ${colorClasses}`}
    >
      {label} ({ratio.toFixed(2)})
    </span>
  );
}
